// theme.js

import { extendTheme } from '@chakra-ui/react';

// Define your custom colors and other theme settings
const customTheme = extendTheme({
  colors: {
    brand: {
      50: '#e3f8ff',
      100: '#b3ecff',
      200: '#81defd',
      300: '#5ed0fa',
      400: '#40c3f7',
      500: '#2bb0ed',
      600: '#1992d4',
      700: '#127fbf',
      800: '#0b69a3',
      900: '#035388',
    },
    // Override other colors or add new ones
    primary: '#FF6347', // Example custom primary color
    secondary: '#1A202C', // Example custom secondary color
    // Custom dark and light mode backgrounds
    light: {
      bg: '#f7fafc',
      text: '#1a202c',
    },
    dark: {
      bg: '#1a202c',
      text: '#f7fafc',
    },
  },
  // You can also extend other aspects of the theme here (fonts, sizes, etc.)
});

export default customTheme;
